import React from 'react'; 
import { Modal, Button } from 'react-bootstrap'; 
import PristupnicaForm from './PristupnicaForm'; // Path to your form component 

const PristupnicaModal = ({ show, onHide, handleSubmitPristupnica }) => { 
    return ( 
        <Modal show={show} onHide={onHide} size="xl" centered> 
            <Modal.Header closeButton> 
                <Modal.Title>Unos podataka za Pristupnicu za ugovaranje paketa Fina e-Račun PLUS</Modal.Title> 
            </Modal.Header> 
            <Modal.Body style={{ maxHeight: '75vh', overflowY: 'auto' }}> 
                <PristupnicaForm onSubmit={handleSubmitPristupnica} /> 
            </Modal.Body> 
            <Modal.Footer> 
                <Button variant="secondary" onClick={onHide}> 
                    Zatvori 
                </Button> 
            </Modal.Footer> 
        </Modal> 
    ); 
};

export default PristupnicaModal;